import React, { lazy, Suspense } from "react";
import { useRoutes } from "react-router-dom";
const COMPONENTS_MAP: Map<
  string,
  React.LazyExoticComponent<React.ComponentType>
> = new Map();
const getCachedLazyComponent = (key: string) => {
  if (COMPONENTS_MAP.has(key)) return COMPONENTS_MAP.get(key);
  const LazyComponent = lazy<React.ComponentType>(() =>
    import(`./containers/${key}/Wrap.Container`).then((m) => m)
  );
  COMPONENTS_MAP.set(key, LazyComponent);
  return LazyComponent;
};
const BrandContainer = getCachedLazyComponent("brandsnap");
const StreetContainer = getCachedLazyComponent("streetsnap");
const StyleListContainer = getCachedLazyComponent("stylelist");
const CodishopContainer = getCachedLazyComponent("codishop");
const CodimapContainer = getCachedLazyComponent("codimap");

const CategoryRoutes = () => {
  const element = useRoutes([
    {
      path: "/mz/brandsnap/view/:pageUid",
      element: (
        <Suspense fallback={<div></div>}>
          {BrandContainer && <BrandContainer />}
        </Suspense>
      ),
    },
    {
      path: "/mz/streetsnap/view/:pageUid",
      element: (
        <Suspense fallback={<div></div>}>
          {StreetContainer && <StreetContainer />}
        </Suspense>
      ),
    },
    {
      path: "/app/styles/views/:pageUid",
      element: (
        <Suspense fallback={<div></div>}>
          {CodishopContainer && <CodishopContainer />}
        </Suspense>
      ),
    },
    {
      path: "/app/codimap/views/:pageUid",
      element: (
        <Suspense fallback={<div></div>}>
          {CodimapContainer && <CodimapContainer />}
        </Suspense>
      ),
    },
    {
      path: "/app/stylecontents/lists",
      element: (
        <Suspense fallback={<div></div>}>
          {StyleListContainer && <StyleListContainer />}
        </Suspense>
      ),
    },
  ]);
  return element;
};
export default CategoryRoutes;
